import type { IAccountRewardStatus } from "@apis/rewards/types"
import { Badge } from "@components/ui/badge"
import { cn } from "@components/ui/lib/utils"
import { parseCurrency } from "@utils/formatters"
import { dateDiffInSeconds } from "./utils/utils"

type TRewardStatusBarProps = {
  reward: {
    statuses: IAccountRewardStatus[]
  }
}

export const RewardStatusBar = ({ reward }: TRewardStatusBarProps) => {
  return (
    <div className="tw:flex tw:items-start tw:justify-center tw:gap-2">
      {reward.statuses.map((status, index) => (
        <>
          <div
            key={`${status.title}-${index}`}
            className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center"
          >
            <Badge
              className={cn(
                "tw:mb-2 tw:flex tw:h-25 tw:w-25 tw:items-center tw:justify-center tw:rounded-full tw:border-4 tw:border-gray-300 tw:text-base",
                status.date && dateDiffInSeconds(status.date) < 0
                  ? "tw:bg-gray-300 tw:text-foreground"
                  : "tw:bg-background tw:text-foreground",
                status.title === "Settled" &&
                  parseCurrency(status.total) > 0 &&
                  "tw:border-green-500 tw:bg-green-500",
              )}
            >
              {status.total}
            </Badge>

            <span className="tw:inline-block tw:self-center tw:text-center tw:font-bold tw:break-words">
              {status.title}
            </span>
            <span
              className="tw:inline-blockt w:self-center tw:text-center tw:break-words"
              dangerouslySetInnerHTML={{
                __html: status.message,
              }}
            />
          </div>

          {index < reward.statuses.length - 1 && (
            <hr className="tw:mt-12 tw:h-[2px] tw:w-12 tw:bg-gray-300" />
          )}
        </>
      ))}
    </div>
  )
}
